<div
  class="bg-elevated border-weak flex h-9 w-full flex-row items-center gap-1 border-b py-1 pr-3 pl-2">
  @if (!isSidebarOpen()) {
    <div
      class="hover:bg-interactive ms-2 flex cursor-pointer items-center rounded-sm p-1"
      tabindex="0"
      (click)="toggleSidebar.emit()"
      (keydown.enter)="toggleSidebar.emit()">
      <i class="text-xl" [class]="burgerIcon"></i>
    </div>
  }
  <div class="flex flex-1 items-center">
    <app-breadcrumb />
  </div>
  <div class="flex-1"></div>
  @if (planPanel.planInView()) {
    <button
      #planPanelToggle
      id="plan-panel-toggle"
      type="button"
      class="hover:bg-accent-interactive relative flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm transition-colors"
      [class.text-accent-main]="planPanel.open()"
      [class.text-text-secondary]="!planPanel.open()"
      [attr.aria-label]="planPanelToggleLabel()"
      [attr.aria-pressed]="planPanel.open()"
      (click)="planPanel.toggle()">
      <i [class]="ICONS.sidebarSimple" aria-hidden="true"></i>
    </button>
    <app-tooltip [target]="planPanelToggle" [content]="planPanelToggleLabel()" />
  }
  @if (assistant.toggleVisible()) {
    <button
      #assistantToggle
      id="assistant-toggle"
      type="button"
      class="hover:bg-accent-interactive relative flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm transition-colors"
      [class.text-accent-main]="assistant.panelOpen() || poppedOut()"
      [class.text-text-secondary]="!assistant.panelOpen() && !poppedOut()"
      [attr.aria-label]="assistantToggleLabel()"
      (click)="onAssistantToggle()">
      <i [class]="ICONS.sparkle"></i>
      @if (poppedOut()) {
        <i
          [class]="ICONS.arrowSquareOut"
          class="bg-elevated absolute right-0.5 bottom-0.5 rounded-xs text-[10px] leading-none"
          aria-hidden="true"></i>
      }
    </button>
    <app-tooltip [target]="assistantToggle" [content]="assistantToggleLabel()" />
  }
  @if (showDataspaceDropdown()) {
    <div
      #dataspaceWrapper
      class="group relative flex items-center justify-center rounded-md">
      <app-dataspace-selector
        [value]="currentDataspaceId()"
        [placeholder]="dataspacePlaceholder()"
        (valueChange)="onDataspaceChange($event)" />
      <app-tooltip [target]="dataspaceWrapper" [content]="dataspaceTooltip()" />
    </div>
  }
</div>
